import { render, staticRenderFns } from "./CalendarDentiste.vue?vue&type=template&id=efd092ee&"
import script from "./CalendarDentiste.vue?vue&type=script&lang=js&"
export * from "./CalendarDentiste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports